module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_BringToFront_16"],"path":[{"$":{"d":"M1,1H3V2H2V3H1ZM2,8H1v2H3V9H2ZM2,4H1V7H2ZM7,1H4V2H7ZM9,3h1V1H8V2H9Zm1,2V4H9V5H5V9H4v1H5v5H15V5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_BringToFront_16.svg
// module id = +85A
// module chunks = 1